export const messages = {
  en: {
    integralShopRule: {
      queryCondition: 'Query Conditions',
      ruleTitle: 'Points Rules',
      query: 'Query',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      cancel: 'Cancel',
      save: 'Save',
      confirmOperation: 'Please confirm your operation!',
      confirmDelete: 'Confirm Delete!',
      confirmDeleteRule: 'Are you sure to delete this points rule?',
      saveSuccess: 'Save successfully',
      updateSuccess: 'Update successfully',
      deleteSuccess: 'Delete successfully',
      id: 'ID',
      ruleName: 'Rule Name',
      money: 'Amount',
      amount: 'Points',
      createTime: 'Create Time',
      operation: 'Operation',
      ruleNamePlaceholder: 'Please enter rule name',
      moneyPlaceholder: 'Please enter amount',
      amountPlaceholder: 'Please enter points',
      ruleNameRequired: 'Rule name is required',
      ruleNameMaxLength: 'Rule name cannot exceed 128 characters',
      moneyRequired: 'Amount is required',
      moneyMaxLength: 'Amount cannot exceed 30 characters',
      amountRequired: 'Points is required',
      amountMaxLength: 'Points cannot exceed 30 characters',
      idRequired: 'ID is required'
    }
  },
  zh: {
    integralShopRule: {
      queryCondition: '查询条件',
      ruleTitle: '积分规则',
      query: '查询',
      add: '添加',
      edit: '修改',
      delete: '删除',
      cancel: '取消',
      save: '保存',
      confirmOperation: '请确认您的操作！',
      confirmDelete: '确认删除！',
      confirmDeleteRule: '确定删除该积分规则吗？',
      saveSuccess: '保存成功',
      updateSuccess: '更新成功',
      deleteSuccess: '删除成功',
      id: '编号',
      ruleName: '规则名称',
      money: '金额',
      amount: '积分数',
      createTime: '创建时间',
      operation: '操作',
      ruleNamePlaceholder: '请输入规则名称',
      moneyPlaceholder: '请输入金额',
      amountPlaceholder: '请输入积分数',
      ruleNameRequired: '规则名称不能为空',
      ruleNameMaxLength: '规则名称不能超过128个字符',
      moneyRequired: '金额不能为空',
      moneyMaxLength: '金额不能超过30个字符',
      amountRequired: '积分数不能为空',
      amountMaxLength: '积分数不能超过30个字符',
      idRequired: '编号不能为空'
    }
  }
}